<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'

/**
 * A column header is operational metadata, so it takes BG §19.3's system-label voice: uppercase mono at
 * the system tracking, in the secondary ink. Uppercased in CSS so a screen reader still reads words.
 */
const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
  <th
    data-slot="table-head"
    :class="cn('text-muted-foreground h-10 px-3 text-left align-middle font-mono text-xs font-medium uppercase tracking-[var(--tracking-system)] whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-0.5', props.class)"
  >
    <slot />
  </th>
</template>
